import { IonCardContent, IonCol, IonGrid, IonRow } from '@ionic/react';
import { ApexOptions } from 'apexcharts';
import { useEffect, useState } from 'react';
// eslint-disable-next-line import/default
import Chart from 'react-apexcharts';

import styles from '@/pages/ReportV2/components/Graphs/ApexCharts.module.css';
import modalStyles from '@/pages/ReportV2/components/Modals/ModalContent.module.css';

import { CardHeader } from '@/components/CardHeader/cardHeader';
import { Card } from '@/components/Cards';
import { ReportModal } from '@/components/Modal/ReportModal';

import { useWindowDimensions } from '@/hooks/useWindowDimensions';

// import { colorLeft, colorRight } from '@/theme/colors';
import { themeColors } from '@/theme/colors';

type ScissorsColumnChartProps = {
  title: string;
  data: any;
  yAxisLabel: string;
};

export const ScissorsColumnChart = ({ title, data, yAxisLabel }: ScissorsColumnChartProps) => {
  const { width, height } = useWindowDimensions();
  const [windowSize, setWindowSize] = useState('small');
  const [showModal, setShowModal] = useState({ show: false });

  useEffect(() => {
    if (height != null) {
      if (height > 860) {
        setWindowSize('large');
      } else {
        setWindowSize('small');
      }
    }
  }, [width]);
  const options: ApexOptions = {
    chart: {
      type: 'bar',
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
      offsetX: 0,
      height: '100%',
    },
    legend: {
      position: 'top',
      horizontalAlign: 'center',
      fontSize: '9px',
      markers: {
        width: 8,
        height: 8,
        radius: 50,
      },
      onItemClick: {
        toggleDataSeries: true,
      },
      offsetY: 10,
    },
    plotOptions: {
      bar: {
        horizontal: false,
        distributed: true,
        columnWidth: '55%',
        borderRadius: 4,
        dataLabels: {
          position: 'top', // top, center, bottom
        },
      },
    },
    dataLabels: {
      enabled: true,
      formatter: function (val: number) {
        return val.toFixed(1) + ` ${yAxisLabel}`;
      },
      offsetY: -20,
      style: {
        fontSize: '10px',
        colors: ['#304758'],
      },
    },
    xaxis: {
      type: 'category',
      categories: ['Left', 'Right'],
      labels: {
        style: {
          fontSize: '8px',
        },
      },
    },
    yaxis: {
      stepSize: 1,
      title: {
        text: yAxisLabel,
        style: {
          color: '#707070',
          fontSize: '8px',
        },
      },
      labels: {
        formatter: function (value: number) {
          return value.toFixed(0);
        },
        style: {
          fontSize: '8px',
        },
      },
    },
    stroke: {
      show: false,
    },
    // title: {
    //   text: title,
    //   align: 'center',
    //   style: {
    //     fontSize: '14px',
    //     fontWeight: 'bold',
    //     fontFamily: 'Montserrat',
    //     color: '#2066FA',
    //   },
    // },
    // subtitle: {
    //   text: subtitle,
    //   align: 'center',
    //   style: {
    //     fontSize: '10px',
    //     fontFamily: 'Montserrat',
    //   },
    //   offsetY: 10,
    // },
    colors: [themeColors.colorLeft, themeColors.colorRight],
    tooltip: {
      enabled: false,
    },
  };

  return (
    <>
      <ReportModal
        header={title}
        isOpen={showModal.show}
        onDidDismiss={() => {
          setShowModal({ show: false });
        }}
        setShowInfo={() => setShowModal({ show: false })}>
        <IonGrid className={modalStyles.Modalcontent_container} fixed>
          <IonRow
            className='ion-align-items-center ion-align-items-stretch ion-padding-vertical ion-margin-vertical ion-justify-content-center'
            style={{ height: '75%' }}>
            <IonCol className='' size='11'>
              <div className={styles.reportModalGraph_Wrapper}>
                <Chart height={'100%'} options={options} series={data} type='bar' width='100%' />
              </div>
            </IonCol>
          </IonRow>
        </IonGrid>
      </ReportModal>

      <Card
        onClick={() => {
          setShowModal({ show: true });
        }}
        style={{ height: '100%', margin: 0 }}>
        <CardHeader title={title} />
        <IonCardContent className='' style={{ paddingLeft: '10px', paddingRight: '10px', paddingBottom: '10px' }}>
          <div className='' style={{ marginLeft: 'auto', marginRight: 'auto' }}>
            <Chart height={windowSize == 'small' ? 125 : 175} options={options} series={data} type='bar' width='100%' />
          </div>
        </IonCardContent>
      </Card>
    </>
  );
};
